import React from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";

const Pagination = ({
  currentPage,
  totalPages = 0,
  onPageChange,
  itemsPerPage = 10,
  onItemsPerPageChange,
  totalCount = 0,
   itemsPerPageOptions = [10, 20, 50, 100, 200, 500],
}) => {
  
 

  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        pageNumbers.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pageNumbers.push(1);
        pageNumbers.push("...");
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        pageNumbers.push(1);
        pageNumbers.push("...");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        pageNumbers.push(totalPages);
      }
    }
    return pageNumbers;
  };

  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    onItemsPerPageChange(newItemsPerPage);
  };

  // Calculate start and end item numbers
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalCount);

  return (
    <div className="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0 py-2.5">
      {/* Mobile: Prev/Next above info, text only */}
      <div className="flex md:hidden w-full justify-between items-center mb-2">
        <button
          className={`prev-btn flex items-center justify-center w-[80px] h-[30px] rounded-md border border-gray-300 text-text2 text-sm font-medium ${
            currentPage === 1 ? "pointer-events-none opacity-50" : "cursor-pointer"
          }`}
          disabled={currentPage === 1}
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        >
          Previous
        </button>
        <button
          className={`flex items-center justify-center w-[80px] h-[30px] rounded-md border border-gray-300 text-text2 text-sm font-medium ${
            currentPage === totalPages ? "pointer-events-none opacity-50" : "cursor-pointer"
          }`}
          disabled={currentPage === totalPages}
          onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
      {/* Mobile: Info row only, no pagination below */}
      <div className="flex md:hidden w-full justify-between items-center mb-2">
        <span className="text-[#374151] text-sm font-medium">
          <span className="text-[12px] sm:text-sm font-medium text-[#374151]">
            {`Showing ${startItem} to ${endItem} of ${totalCount} results`}
          </span>
        </span>
        <div className="flex items-center space-x-2">
          <span className="text-text3 text-[12px] sm:text-sm">Results per page:</span>
          <div className="custom-dropdown">
            <select
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
              className="rounded px-1 py-0 text-sm h-[30px] font-normal text-text2 uppercase focus:outline-none focus:ring-0              w-full  cursor-pointer"
            >
              {itemsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      {/* Desktop layout */}
      <div className="hidden md:flex items-center space-x-2">
          <span className="text-text3 text-xs sm:text-sm">Results per page:</span>
        <div className="custom-dropdown">
          <select
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
            className="rounded px-1 py-0 text-[12px] sm:text-sm h-[24px] font-normal text-text2 uppercase focus:outline-none focus:ring-0 w-full cursor-pointer"
          >
            {itemsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="flex items-center">
        {/* Desktop only: Prev/Next with icons and page numbers */}
        <button
          className={`prev-btn hidden md:flex items-center justify-center w-[30px]  h-[30px]  rounded-tl-md rounded-bl-md border-solid  border border-gray-300 ${
            currentPage === 1 ? "pointer-events-none" : "cursor-pointer"
          }`}
          disabled={currentPage === 1}
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        >
          <FaAngleLeft className="text-gray-500" />
        </button>
        <div className="hidden md:flex">
          {getPageNumbers().map((pageNumber, index) => (
            <button
              key={index}
              className={`flex items-center justify-center w-[30px] h-[30px] border-[1px]  border-gray-300 px-4 py-2 ${
                pageNumber === "..." ? "border-none" : "cursor-pointer"
              } ${
                currentPage === pageNumber
                  ? " text-text1 bg-[#E5E7EB] border-[#E5E7EB]"
                  : "text-text2"
              }`}
              disabled={pageNumber === "..."}
              onClick={() => pageNumber !== "..." && onPageChange(pageNumber)}
            >
              {pageNumber}
            </button>
          ))}
        </div>
        <button
          className={`hidden md:flex items-center justify-center w-[30px] h-[30px] rounded-tr-md rounded-br-md  border-l-1  border border-gray-300 ${
            currentPage === totalPages
              ? "pointer-events-none"
              : "cursor-pointer"
          }`}
          disabled={currentPage === totalPages}
          onClick={() =>
            currentPage < totalPages && onPageChange(currentPage + 1)
          }
        >
          <FaAngleRight className="text-gray-500" />
        </button>
      </div>
     {/* Desktop results count */}
<div className="hidden md:block">
  <span className="text-[#374151] text-sm font-normal">
    Showing{" "}
    <span className="font-medium">{startItem}</span>{" "}
    to{" "}
    <span className="font-medium">{endItem}</span>{" "}
    of{" "}
    <span className="font-medium">{totalCount}</span>{" "}
    results
  </span>
</div>
    </div>  
  );
};

export default Pagination;
